/**
 * Implement Gatsby's Browser APIs in this file.
 * These allow customization/extension of default Gatsby settings affecting the browser.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

//css
import React from 'react';
import { CartProvider } from './src/hooks/useCart.js/useCart';
import './src/styles/scss/global.scss';

// TODO: Gatsby v5 bug with scroll restoration, refactor when resolved
// https://github.com/gatsbyjs/gatsby/issues/38201
export const shouldUpdateScroll = ({
  prevRouterProps,
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // if location is equal to previous location
  if (prevRouterProps?.prevLocation?.pathname === location.pathname) {
    return false;
  }

  window.history.scrollRestoration = 'manual';
  const currentPosition = getSavedScrollPosition(location, location.key);
  if (!currentPosition) {
    window.scrollTo(0, 0);
  } else {
    window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        window.scrollTo(...currentPosition);
      });
    }, 0);
  }

  return false;
};

export const wrapRootElement = ({ element }) => (
  <CartProvider>{element}</CartProvider>
);
